// extracted by mini-css-extract-plugin
module.exports = {"split":"ClientInfo_split__1b4ds","column":"ClientInfo_column__1Matq"};